import Dispatcher from "../dispatcher";

const MarkerStore = {
  _state: {
    markers: [],
    subscribedMarkers: []
  },
  isLoading: false,

  _updateState(state) {
    const newState = Object.assign({}, this._state, state);
    newState.markerHash = this._getMarkerHash(this.combinedMarkers(newState));
    this._state = newState;
    this._updateMarkerColors();
    Dispatcher.emit(Dispatcher.MARKERS_CHANGE);
  },

  get(id) {
    this._load();
    if (!this._state || !this._state.markerHash) {
      return undefined;
    }
    return this._state.markerHash[id];
  },

  getAll() {
    this._load();
    return this._state;
  },

  // TODO remove tmp functions
  __tmpSetMarkers(data) {
    let markers = this.getAll();
    this._updateState({
      markers: data.markers,
      subscribedMarkers: data.subscribedMarkers,
      currentMarker: markers.currentMarker || data.markers[0]
    });
  },

  _getCombinedMarkers() {
    let markers = this.getAll();
    return markers.markers.concat(markers.subscribedMarkers);
  },

  _getMarkerHash(markerList) {
    let hash = {};
    markerList.map(marker => {
      hash[marker.globalId] = marker;
    });
    return hash;
  },

  _setCurrentMarker(marker) {
    if (marker) {
      this._updateState({ currentMarker: marker });
    }
  },

  getCurrentMarker() {
    const markers = this.getAll();
    if (markers.currentMarker) {
      return markers.currentMarker;
    } else {
      return { label: "" };
    }
  },

  combinedMarkers(markersObj) {
    markersObj = markersObj || this.getAll();
    if (markersObj.markers) {
      return markersObj.markers.concat(markersObj.subscribedMarkers);
    } else {
      return [];
    }
  },

  _updateMarkerColors() {
    const markers = this.combinedMarkers();
    markers.forEach(marker => {
      marker.darkColor = marker.vstColorDark;
      marker.color = marker.vstColor;
    });
  },

  _load(update) {
    // TODO implement this eventually
    //  Draft implementation available in history
  },

  init() {
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() + 2);
    Dispatcher.bind(Dispatcher.MARKERS_DELETE, id => {});
    Dispatcher.bind(Dispatcher.MARKERS_SET_CURRENT, marker => {
      this._setCurrentMarker(marker);
    });
  }
};

MarkerStore.init();
export default MarkerStore;
